module.exports = __webpack_public_path__ + "static/media/sd.b4a4e876.webp";